import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getTicketReports = createAsyncThunk(
  'ticketReport/getTicketReports',
  async ({ skip, limit, created_from, created_to, lottery_brand_code, lottery_brand_day_code, draw_no, ticket_status, payment_status, search }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params: {
          ...(skip ? { skip: skip - 1 } : {}),
          ...(limit ? { limit } : {}),
          ...(created_from ? { created_from } : {}),
          ...(created_to ? { created_to } : {}),
          ...(lottery_brand_code ? { lottery_brand_code} : {}),
          ...(lottery_brand_day_code ? { lottery_brand_day_code } : {}),
          ...(draw_no ? { draw_no } : {}),
          ...(ticket_status ? { ticket_status } : {}),
          ...(payment_status ? { payment_status } : {}),
          ...(search ? { search } : {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/tickets/filter`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const downloadTicketReportsList = createAsyncThunk(
  'ticketReport/downloadTicketReportsList',
  async ({ skip, limit, created_from, created_to, lottery_brand_code, lottery_brand_day_code, draw_no, ticket_status, payment_status, search }, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params: {
          ...(skip ? { skip: skip - 1 } : {}),
          ...(limit ? { limit } : {}),
          ...(created_from ? { created_from } : {}),
          ...(created_to ? { created_to } : {}),
          ...(lottery_brand_code ? { lottery_brand_code} : {}),
          ...(lottery_brand_day_code ? { lottery_brand_day_code } : {}),
          ...(draw_no ? { draw_no } : {}),
          ...(ticket_status ? { ticket_status } : {}),
          ...(payment_status ? { payment_status } : {}),
          ...(search ? { search } : {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/tickets/ticket-list-download`,
        config
      );
      if (response.status === 200) {
        downloadReport(response.data, `Tickets Report.csv`);
      }
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

const downloadReport = (blob, filename) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};
